import readConfig from './config.js'
import formGate from './form-gate.js'
import loginRetry from './login-retry.js'
import offcanvasLogin from './offcanvas-login.js'
import solution from './solution.js'
import widget from './widget.js'

export default function createFriendlyCaptchaWidget() {
    return {
        ...solution,
        ...widget,
        ...formGate,
        ...offcanvasLogin,
        ...loginRetry,

        frcCaptchaIsVisible: false,
        isCustomerLoggedIn: false,
        customerStateResolved: false,
        widgetInitialized: false,
        eventListenersAttached: false,
        offcanvasHandlersAttached: false,
        isStarted: false,
        initAttempts: 0,
        buttonInitiallyDisabled: null,
        widgetInitWarned: false,
        visibilityTimer: null,

        config: null,
        widgetElement: null,
        form: null,
        buttonElement: null,
        buttonWrapper: null,
        widget: null,
        originalFormSubmit: null,
        originalRequestSubmit: null,
        pendingSubmitAction: null,
        pendingSubmitter: null,
        offcanvasLoginTrigger: null,
        boundHandlers: {},

        init() {
            this.config = readConfig(this.$el)
        },

        initWidget() {
            if (!this.initMarkup()) {
                return
            }

            if (this.widgetInitialized) {
                return
            }

            if (!this.waitForWidgetConstructor()) {
                return
            }

            this.createWidget()
            this.attachFormGate()
            this.attachOffcanvasStart()
            this.attachLoginRetryReset()
            this.setupDoneCallback()
        },

        initMarkup() {
            this.widgetElement = this.$el || null
            this.form = this.widgetElement?.closest('form') || null
            this.buttonElement = this.form?.querySelector('button[type="submit"]') || null

            if (!this.widgetElement || !this.form || !this.buttonElement) {
                if (!this.widgetInitWarned) {
                    console.warn('FriendlyCaptcha widget markup is incomplete.')
                    this.widgetInitWarned = true
                }

                return false
            }

            this.buttonWrapper = this.buttonElement.closest('.actions-toolbar') ||
                this.buttonElement.closest('div')

            if (this.buttonInitiallyDisabled === null) {
                this.buttonInitiallyDisabled = this.buttonElement.disabled
            }

            if (!this.originalFormSubmit) {
                this.originalFormSubmit = this.form.submit.bind(this.form)
            }

            if (!this.originalRequestSubmit && typeof this.form.requestSubmit === 'function') {
                this.originalRequestSubmit = this.form.requestSubmit.bind(this.form)
            }

            if (!this.widgetInitialized) {
                this.buttonElement.disabled = true
            }

            return true
        },

        setCustomerState(data) {
            this.isCustomerLoggedIn = Object.hasOwn(data?.customer ?? {}, 'signin_token')

            if (this.customerStateResolved) {
                return
            }

            this.customerStateResolved = true

            if (!this.isCustomerLoggedIn) {
                this.initWidget()
            }
        },

        queuePendingSubmit(action = 'requestSubmit', submitter = null) {
            this.pendingSubmitAction = action
            this.pendingSubmitter = submitter
        },

        clearPendingSubmit() {
            this.pendingSubmitAction = null
            this.pendingSubmitter = null

            if (this.form) {
                this.form.friendlyCaptchaResumeSubmit = null
            }
        },

        resumePendingSubmit() {
            const action = this.pendingSubmitAction
            const submitter = this.pendingSubmitter

            this.clearPendingSubmit()

            if (!action) {
                return
            }

            if (action === 'submit') {
                this.originalFormSubmit()
                return
            }

            if (this.originalRequestSubmit) {
                if (submitter) {
                    this.originalRequestSubmit(submitter)
                    return
                }

                this.originalRequestSubmit()
                return
            }

            if (submitter && typeof submitter.click === 'function') {
                submitter.click()
                return
            }

            if (this.buttonElement && typeof this.buttonElement.click === 'function') {
                this.buttonElement.click()
                return
            }

            this.originalFormSubmit()
        }
    }
}
